export default {
  "Menu.Title": "サイトマップ",
  "Menu.Top": "「ダッシュボードトップ」へ",
  "Menu.DisplayAgreement": "「同意事項一覧」へ",
  "Menu.NoticeConfig": "「お知らせ配信の設定」へ",
  "Menu.ThirdParty": "「第三者提供の管理」へ",
  "Menu.Account": "「連携サービス一覧」へ",
  "Menu.Location": "「位置情報利用の管理」へ",
  "Menu.Information": "「お知らせ一覧」へ",
}
